export const MAX_FEEDBACK_LENGTH = 1000;

export const normalizeFeedback = (value?: string): string => {
  if (value === undefined || value === null) return "";
  return String(value).trim();
};

export const isValidFeedback = (value?: string): boolean => {
  const normalized = normalizeFeedback(value);
  return normalized.length <= MAX_FEEDBACK_LENGTH;
};
